import { defineComponent as _defineComponent } from 'vue'
import { MissionStaffingApplicationFragmentFragment } from "@/gql"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import DetailsCard from "./DetailsCard.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationsOverview',
  props: {
    application: null,
    refetchQueries: null
  },
  setup(__props: any) {



return { __sfc: true,DetailsCard }
}

})